import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ChatWidget from "./components/ChatWidget";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import SurveySearch from "./pages/SurveySearch";
import Contact from "./pages/Contact";
import FeeScale from "./pages/FeeScale";
import Consultation from "./pages/Consultation";
import PropertyHub from "./pages/PropertyHub";
import ArticlePage from "./pages/ArticlePage";
import Admin from "./pages/Admin";
import { Toaster } from "./components/ui/toaster";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/survey-search" element={<SurveySearch />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/fee-scale" element={<FeeScale />} />
            <Route path="/consultation" element={<Consultation />} />
            <Route path="/property-hub" element={<PropertyHub />} />
            <Route path="/property-hub/:slug" element={<ArticlePage />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
        <Footer />
        <ChatWidget />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
